import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { FormField, ResultCard } from '../finance/shared';

const DaysUntilCalculator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [targetDate, setTargetDate] = useState('2024-12-31');
  const [resultState, setResultState] = useState<any>(null);

  const calculate = () => {
    if (!targetDate) return;
    const target = new Date(targetDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const diffTime = target.getTime() - today.getTime();
    const daysUntil = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (daysUntil < 0) {
      setResultState({ isPast: true });
      onResultChange([{ label: 'Status', value: 'Data no passado' }]);
      return;
    }

    const weeks = Math.floor(daysUntil / 7);
    const months = Math.floor(daysUntil / 30.44);
    const res = { daysUntil, weeks, months, isPast: false };

    setResultState(res);
    onResultChange([
      { label: 'Dias Faltantes', value: res.daysUntil.toString() },
      { label: 'Semanas', value: res.weeks.toString() },
      { label: 'Meses', value: res.months.toString() }
    ]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl border border-theme-border shadow-sm">
        <FormField label="Data Alvo" value={targetDate} onChange={setTargetDate} type="date" required />
        <div className="flex justify-center mt-8">
          <button onClick={calculate} className="px-10 py-4 bg-accent-gradient text-white rounded-xl font-bold shadow-accent hover:scale-105 transition-all flex items-center gap-2">
            <Icon name="play" className="w-5 h-5" /> Calcular
          </button>
        </div>
        {resultState && !resultState.isPast && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
            <ResultCard title="Dias" value={resultState.daysUntil} color="orange" />
            <ResultCard title="Semanas" value={resultState.weeks} color="purple" />
            <ResultCard title="Meses" value={resultState.months} color="indigo" />
          </div>
        )}
      </div>
    </div>
  );
};

export default DaysUntilCalculator;
